module.exports = __webpack_public_path__ + "img/pc_p3_x4.119246f5.svg";